import type { Program, ChartSettings } from '../types';

interface ProgramNodeProps {
  pcx: number;
  pcy: number;
  discR: number;
  ring: number;
  prog: Program;
  groupColor: string | null;
  gi: number;
  pi: number;
  nP: number;
  isSelected: boolean;
  onSelect: () => void;
  settings: ChartSettings;
}

export default function ProgramNode({ pcx, pcy, discR, ring, prog, groupColor, gi, pi, nP, isSelected, onSelect, settings }: ProgramNodeProps) {
  const col = prog.color || groupColor || null;
  const fill = prog.fill || settings.progFill;
  const txt = prog.textColor || settings.progText;
  const fsz = prog.fontSize || settings.progFont;
  const plines = String(prog.label).split('\n');
  const plh = fsz * 1.25;
  const vacN = prog.people.filter(p => p.vacant).length;
  const fteText = prog.fte != null && prog.fte !== ''
    ? `${prog.fte} FTE`
    : `${vacN ? `${nP - vacN}+${vacN}V` : nP} FTE`;
  const pillY = pcy + ring + 20;
  return (
    <>
      <g
        className={`pnode${isSelected ? ' on' : ''}`}
        data-type="prog" data-gi={gi} data-pi={pi}
        tabIndex={0} role="button"
        aria-label={`${prog.short} — ${nP} people. Open record.`}
        onClick={onSelect}
        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelect(); } }}
      >
        <circle className="psel" cx={pcx} cy={pcy} r={discR + 10} />
        <circle className="disc-p" cx={pcx} cy={pcy} r={discR}
          style={{ fill, ...(col ? { stroke: col } : {}) }} />
        {plines.map((ln, li) => (
          <text key={li} className="pname" x={pcx}
            style={{ fontSize: `${fsz}px`, fill: txt }}
            y={pcy - (plines.length - 1) * plh / 2 + li * plh + fsz * 0.4}>{ln}</text>
        ))}
        <text className="fte" x={pcx} y={pcy + discR - 9}
          style={prog.badgeColor ? { fill: prog.badgeColor } : undefined}>{fteText}</text>
      </g>
      {settings.showPills && (
        <>
          <rect className="pill" x={pcx - 50} y={pillY} width={100} height={20} rx={10} />
          <text className="pilltxt" x={pcx} y={pillY + 13}>{`${prog.id} · ${nP} FTE`}</text>
        </>
      )}
    </>
  );
}
